<template>
  <div class="page">
    <div class="page__left">
      <div class="page__header">
        <router-link :to="{ name: 'Main' }" class="page__header_title">
          ЭТО<b
            >ПРОСЧЕТ
            <span v-if="currentCalculation">{{
              currentCalculation.name
            }}</span></b
          >
        </router-link>
        <div class="page__header_info">
          Заявка #{{ formatOrder
          }}<span
            >-
            <label>
              <input
                type="text"
                class="page__header_name"
                v-autowidth="{
                  maxWidth: '20rem',
                  minWidth: '3.6rem',
                  comfortZone: 0
                }"
                v-model="extra"
                placeholder="0"
                v-mask="'###'"
                v-int
              />
            </label>
          </span>
          Для
          <label>
            <input
              type="text"
              class="page__header_name"
              v-autowidth="{
                maxWidth: '20rem',
                minWidth: '3.6rem',
                comfortZone: 0
              }"
              v-model="user"
              placeholder="ФИО"
            />
          </label>
          от {{ time }}
        </div>
      </div>

      <div class="page__list" v-if="currentCalculation">
        <FastCost v-if="false" />
        <!--        <Fast-cost />-->
        <!--        <Corps-fast />-->

        <template v-if="currentCalculation['corps']">
          <Corps
            v-for="(item, index) in currentCalculation['corps']
              .slice()
              .reverse()"
            :key="item.id"
            :item="item"
            :id="item.id"
            :index="index"
            :isLast="currentCalculation['corps'].length !== index + 1"
          />
        </template>

        <template v-if="currentCalculation['facades']">
          <Facades
            v-for="(item, index) in currentCalculation['facades']
              .slice()
              .reverse()"
            :key="item.id"
            :item="item"
            :id="item.id"
            :index="index"
            :isLast="currentCalculation['facades'].length !== index + 1"
          />
        </template>

        <div v-for="category in listCategory" :key="category">
          <template v-if="currentCalculation[category]">
            <Other
              v-for="(item, index) in currentCalculation[category]
                .slice()
                .reverse()"
              :key="item.id"
              :item="item"
              :id="item.id"
              :index="index"
              :isLast="currentCalculation[category].length !== index + 1"
              :title="namesCategory[category]"
              :category="category"
            />
          </template>
        </div>
      </div>
    </div>
    <div class="page__right">
      <pre
        v-if="0"
        style="line-height: 1;font-size: 0;position: fixed;right: 0;top: 45%;overflow: auto;
                    background: rgba(255, 255, 255, 0.95);padding: 1rem 2rem;width: 39rem;z-index: 100;
                    bottom: 8rem;"
      >
        <small>
          <code style="font-size: 1.1rem">
            {{ currentCalculation }}
          </code>
        </small>
      </pre>

      <div class="calc">
        <CalcItem
          v-for="(calc, index) in calculationList"
          :index="index"
          :key="calc.name"
          :item="calc"
        />
      </div>

      <button
        v-if="calculationList.length < 3"
        class="calc__add btn"
        type="button"
        @click="addCalculation"
      >
        <span class="icon icon-plus"></span>
      </button>
      <div class="calc__bottom">
        <button
          class="calc__order btn"
          type="button"
          :disabled="currentOrder && currentOrder.list.length > 1"
          @click="goToOrder"
        >
          ОФОРМИТЬ ДОГОВОР
        </button>
        <button class="btn" type="button" @click="goToOffer">
          СФОРМИРОВАТЬ КП
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Corps from "@/components/Items/Corps";
import Facades from "@/components/Items/Facades";
import CalcItem from "@/components/Calc-item";
import wNumb from "wnumb";
import Other from "@/components/Items/Other";
import ItemTemplate from "@/utils/ItemTemplate";
import FastCost from "@/components/Fast-cost";

export default {
  name: "Page",
  // eslint-disable-next-line vue/no-unused-components
  components: { FastCost, Other, Corps, Facades, CalcItem },
  data() {
    return {
      number: 0,
      order: "",
      user: "",
      time: ""
    };
  },
  computed: {
    listCategory() {
      return ItemTemplate.listCategory().splice(2);
    },
    namesCategory() {
      return ItemTemplate.namesCategory();
    },
    calculationList() {
      return this.$store.getters.calculationList ?? [];
    },
    orderList() {
      return this.$store.getters.orderList;
    },
    optionsList() {
      return this.$store.getters.getOptions;
    },
    currentOrder() {
      return this.$store.getters.currentOrder;
    },
    currentCalculation() {
      return this.$store.getters.currentCalculation;
    },
    formatOrder() {
      return wNumb({
        thousand: "-"
      }).to(this.number);
    },
    extra: {
      get() {
        return this.currentOrder?.extra;
      },
      set(val) {
        this.updateExtra(Math.min(Math.max(val, 0), 100));
      }
    }
  },
  watch: {
    user() {
      this.updateName();
    },
    currentOrder: {
      handler() {
        this.updateInfo();
      },
      immediate: true
    },
    orderList: {
      handler() {
        if (this.orderList?.length ?? 0 > 0) {
          const orderId = this.$route.params.id;
          this.$store.dispatch("setOrder", orderId ?? "");
        }
      },
      immediate: true
    }
  },
  methods: {
    async logout() {
      await this.$store.dispatch("logout");
      this.$router.push("/");
    },
    addCalculation() {
      this.$store.dispatch("addCalculation");
    },
    updateInfo() {
      if (this.currentOrder) {
        const { order, user, time, number } = this.currentOrder;
        this.order = order;
        this.user = user;
        this.time = time;
        this.number = number;
      }
    },
    updateName() {
      this.$store.dispatch("updateOrderName", {
        order: this.order,
        user: this.user
      });
    },
    updateExtra(val) {
      this.$store.dispatch("updateOrderExtra", { extra: val });
    },
    goToOrder() {
      this.$router.push({ name: "Order" });
    },
    goToOffer() {
      this.$router.push({ name: "Offer" });
    }
  }
};
</script>
